module.exports = __webpack_public_path__ + "static/media/children_area.f739a1dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/children_area.svg
// module id = 1491
// module chunks = 0